// our-landing page slider
$('.multi_images').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots:true,
  // autoplay:true,
  // adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
       arrows:false
      }
    },
  ]
});

 // $('.redirect_button a,.custom_button a').click(function(e) {
 //    e.preventDefault();
 //    $('html, body').animate({
 //      scrollTop: $("#custom_bundle_section").offset().top
 //    }, 1000)
 //  });
